import { gql } from '@apollo/client';
import changeDateRequestEventFragment from '@shared/fragments/changeDateRequestEventFragment';
import eventAssignmentsFragment from '../eventAssignmentsFragment';

const REVIEW_CHANGE_DATE_REQUEST = gql`
  mutation ReviewChangeDateRequest($requestData: AppraiserEventChangeDateReviewedInput!) {
    reviewChangeDateRequest(requestData: $requestData) {
      ...ChangeDateRequestEventFields
      EventAssignments {
        ...EventAssignmentsFields
      }
    }
  }

  ${changeDateRequestEventFragment}
  ${eventAssignmentsFragment}
`;

export default REVIEW_CHANGE_DATE_REQUEST;
